// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.builder-initial-image {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 84px;
}
.builder-initial-image img {
  width: 100%;
  margin: 0 auto;
  max-height: 268px;
  max-width: 268px;
  border: 1px solid var(--black2);
  border-radius: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/builder/screens/visual/EditorMenu/components/SettingsSelectImage/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACF;AACE;EACE,WAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,+BAAA;EACA,qBAAA;AACJ","sourcesContent":[".builder-initial-image {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 84px;\n\n  img {\n    width: 100%;\n    margin: 0 auto;\n    max-height: 268px;\n    max-width: 268px;\n    border: 1px solid var(--black2);\n    border-radius: .5rem;\n  };\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
